import React, { forwardRef } from "react";

const Input = forwardRef(function Input(
  { label, icon, error, variant = "underline", labelColor = "secondary", className = "", ...props },
  ref,
) {
  const inputBase =
    "w-full bg-surface-container-low text-on-surface text-[13px] placeholder:text-on-surface-faint rounded-lg border border-outline transition-colors duration-150 focus:border-primary focus:ring-[3px] focus:ring-primary/[.14] focus:outline-none";

  const paddingClasses = variant === "box" ? "py-3" : "py-2.5";

  return (
    <div className={`space-y-2 ${className}`}>
      {label && (
        <label
          htmlFor={props.id}
          className="font-sans text-xs font-medium text-on-surface-variant flex items-center gap-2"
        >
          {label}
        </label>
      )}
      <div className="relative group">
        {icon && (
          <span className="material-symbols-outlined absolute left-3.5 top-1/2 -translate-y-1/2 text-on-surface-faint group-focus-within:text-primary transition-colors text-lg">
            {icon}
          </span>
        )}
        <input
          ref={ref}
          className={`${inputBase} ${paddingClasses} ${icon ? "pl-11 pr-4" : "px-3.5"} ${error ? "border-error focus:border-error focus:ring-error/[.14]" : ""}`}
          {...props}
        />
      </div>
      {error && <p className="text-error text-xs font-medium">{error}</p>}
    </div>
  );
});

export default Input;
